
import React from 'react';
import Reveal from '../components/Reveal';
import SEO from '../components/SEO';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "7 Bedroom Duplex with Pool & BQ",
      category: "Residential",
      imageUrl: "/images/7 bedroom duplex with swimming pool and BQ. EFAB Metropolis Abuja..jpeg",
      description: "Exquisite 7-bedroom duplex with swimming pool and BQ at EFAB Metropolis, Abuja."
    },
    {
      id: 2,
      title: "6 Bedroom Duplexes in Lekki",
      category: "Residential",
      imageUrl: "/images/6 bedroom duplexes Lekki  Lagos..png",
      description: "Modern 6-bedroom duplexes situated in the prime area of Lekki, Lagos."
    },
    {
      id: 3,
      title: "5 Bedroom Upgraded Duplex",
      category: "Residential",
      imageUrl: "/images/5 bedroom duplex with upgraded inside and outside facilities. EFAB Estate Abuja..png",
      description: "Upgraded 5-bedroom duplex with premium facilities at EFAB Estate, Abuja."
    },
    {
      id: 4,
      title: "5 Bedroom Duplex with Pool & BQ",
      category: "Residential",
      imageUrl: "/images/5 bedroom duplex with swimming pool and BQ.png",
      description: "Luxury 5-bedroom duplex featuring a swimming pool and boys' quarters."
    },
    {
      id: 5,
      title: "6 Bedroom Duplex with Pool & BQ",
      category: "Residential",
      imageUrl: "/images/6 bedroom duplex with swimming pool and BQ at Lekki peninsular Scheme 2 Lagos..png",
      description: "Spacious 6-bedroom duplex located at Lekki Peninsula Scheme 2, Lagos."
    },
    {
      id: 6,
      title: "7 Bedroom Duplex with Pool & 2 BQ",
      category: "Residential",
      imageUrl: "/images/7 bedroom duplex with swimming pool and 2 bedroom BQ. EFAB Metropolis Karsana Abuja..png",
      description: "Grand 7-bedroom duplex with pool and 2-bedroom BQ at EFAB Metropolis Karsana, Abuja."
    }
  ];

  return (
    <div className="projects-page">
      <SEO 
        title="Our Projects | Sotak Investment & Property" 
        description="Browse our portfolio of completed and ongoing luxury real estate projects and construction developments."
      />
      <section className="page-header projects-header">
        <div className="container">
          <Reveal>
            <h1>Our Projects</h1>
            <p>Delivering impact through world-class development.</p>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="projects-grid">
            {projects.map((project, index) => (
              <Reveal key={project.id} delay={index * 100} className="project-card">
                <div className="project-image">
                  <img src={project.imageUrl} alt={project.title} />
                  <div className="project-overlay">
                    <span className="project-category">{project.category}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
